export const SETS_RETRIEVE_REQUEST = 'SETS_RETRIEVE_REQUEST';
export const SETS_RETRIEVE_SUCCESS = 'SETS_RETRIEVE_SUCCESS';
export const SETS_RETRIEVE_FAILURE = 'SETS_RETRIEVE_FAILURE';

export const SETS_EDIT_REQUEST = 'SETS_EDIT_REQUEST';
export const SETS_EDIT_SUCCESS = 'SETS_EDIT_SUCCESS';
export const SETS_EDIT_FAILURE = 'SETS_EDIT_FAILURE';

export const SETS_CREATE_REQUEST = 'SETS_CREATE_REQUEST';
export const SETS_CREATE_SUCCESS = 'SETS_CREATE_SUCCESS';
export const SETS_CREATE_FAILURE = 'SETS_CREATE_FAILURE';

export const SETS_DELETE_REQUEST = 'SETS_DELETE_REQUEST';
export const SETS_DELETE_SUCCESS = 'SETS_DELETE_SUCCESS';
export const SETS_DELETE_FAILURE = 'SETS_DELETE_FAILURE';

export const SETS_CANCEL_ALL_REQUESTS = 'SETS_CANCEL_ALL_REQUESTS';
export const SETS_CANCEL_CREATE_REQUEST = 'SETS_CANCEL_CREATE_REQUEST';

export const SET_SELECTED_SUCCESS = 'SET_SELECTED_SUCCESS'

export const SET_LIST_COLLAPSE = 'SET_LIST_COLLAPSE';
export const SET_LIST_CLEAR = 'SET_LIST_CLEAR';
